module.exports = __webpack_public_path__ + "img/326.aa8de673.jpg";